module.exports = __webpack_public_path__ + "museosans300-webfont.987a71c1fbf66595d365.woff2";


//////////////////
// WEBPACK FOOTER
// D:/api-fronted/css/fonts/museosans300-webfont.woff2
// module id = ../../../../../css/fonts/museosans300-webfont.woff2
// module chunks = styles